<template>
  <div class="home">
    <hero
      question="Magst du"
      question1="Bienen"
      question2="Blühwiesen"
      question3="dich"
      claim="Prima! Natürlich kannst du dir mit der Blühpatenschaft auch einfach selbst eine Freude bereiten."
      solution="Vielleicht hast du sowieso schon vor Längerem beschlossen, dass du den Bienen und vielen anderen Insekten etwas Gutes tun möchtest. Doch leider fehlt dir ein Garten oder Balkon? Dann hast du jetzt die Chance, die Patenschaft für ein Stück Bienenweide zu übernehmen. Und das Beste: Um das Aussäen und die Pflege deiner Blumen kümmern wir uns für dich."
    />
    <textblock
      headline="Mache dir selbst eine Freude mit einer Blühpatenschaft!"
      column1="Liebst du es auch so sehr, im Sommer mit dem Fahrrad an den Blumenfeldern entlang zu radeln? Gemeinsam mit dir möchten wir unser Land noch viel bunter machen und wünschen uns dabei deine Unterstützung. Für jeden Quadratmeter Wilde Pracht, für den du eine Patenschaft übernimmst, säen wir auf genau dieser Fläche auf einem Feld Wildblumensamen aus. Unsere ersten Felder liegen übrigens mitten in Schleswig-Holstein – doch das ist nur der Anfang. Denn in Zukunft möchten wir noch viel mehr Landwirte für unsere Idee begeistern."
      column2="Deine Patenschaft für die Bienenweide übernimmst du für jeweils eine Blühsaison. Unten im Formular kannst du ganz leicht auswählen, wie viele Quadratmeter du haben möchtest und in drei kurzen Schritten deinen Kauf abschließen. Selbstverständlich kannst du dir auch eine Blühkarte herunterladen, die du anschließend auch noch per Post bekommst. In den kommenden Monaten halten wir dich außerdem regelmäßig mit unserer Bienenpost auf dem Laufenden, was auf der Bienenweide gerade so passiert. Du darfst gespannt sein!"
    />
    <cta
      title="Werde jetzt Pate für die Blühsaison 2025."
      subtitle="Und schenke dir selbst ein Stück Bienenweide."
    />
    <Orderform />
  </div>
</template>

<script type="text/babel">
// @ is an alias to /src
import Hero from "@/components/Hero.vue";
import Textblock from "@/components/Textblock.vue";
import Cta from "@/components/Cta.vue";
import Orderform from "@/components/Orderform/Orderform.vue";

export default {
  name: "Einfachso",
  components: {
    Hero,
    Textblock,
    Cta,
    Orderform
  },
  metaInfo: {
    title: "Magst du Bienen? | Wilde Pracht",
    meta: [
      {
        name: "description",
        content:
          "Und möchtest du sie gerne schützen, aber dir fehlt der Garten oder Balkon für eine Bienenweide? Dann haben wir da etwas für dich – ein Stück Blühwiese."
      },
      { itemprop: "name", content: "Magst du Bienen? | Wilde Pracht" },
      {
        property: "og:title",
        content: "Magst du Bienen? | Wilde Pracht"
      },
      {
        itemprop: "description",
        content:
          "Und möchtest du sie gerne schützen, aber dir fehlt der Garten oder Balkon für eine Bienenweide? Dann haben wir da etwas für dich – ein Stück Blühwiese."
      },
      {
        property: "og:description",
        content:
          "Und möchtest du sie gerne schützen, aber dir fehlt der Garten oder Balkon für eine Bienenweide? Dann haben wir da etwas für dich – ein Stück Blühwiese."
      }
    ]
  }
};
</script>

<style lang="scss"></style>
